import { render, staticRenderFns } from "./seccionCodigos.vue?vue&type=template&id=2ab2c422"
import script from "./seccionCodigos.vue?vue&type=script&lang=js"
export * from "./seccionCodigos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports